var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vx-row mb-6"},[_vm._m(0),_c('div',{staticClass:"vx-col sm:w-3/4 w-full"},[_c('datepicker',{attrs:{"name":"date","inline":false,"placeholder":"Select Date"},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vx-col sm:w-1/4 w-full flex items-center"},[_c('span',[_vm._v("Open Key Date")])])
}]

export { render, staticRenderFns }